__turbopack_context__.v({
  "Separator": "app-slider-module__kvmA6q__Separator",
  "Slider": "app-slider-module__kvmA6q__Slider",
});
